/* tslint:disable:typedef-whitespace align no-trailing-whitespace no-inferrable-types */

import { Action, ActionType    } from '@/models/action';
import { ProjectService }        from "@/services/project.service";

/**
 *
 * @class ProfileAction
 *
 * @brief close the current project if there is one
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectCloseAction extends Action {

  private projects: ProjectService    = null;

  /** name of the active project...if there is one */
  private projectName: string = '';
  private  projectKey: string = '';

  constructor(options: any = null) {

    super({
      key:   'project.close',
      type:  ActionType.Project_Close,
      label: 'Close \'No Project\'',
      icon:  '<i class="fas fa-hand-paper"></i>',
      tip:   'Close the current project if there is one'
    });

    this.projects = this.injector().get(ProjectService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return this.projectName !== '';
  }

  /**  update label for active project */
  public setProject(name: string = '', key: string = '') {

    this.projectName = name;
    this.projectKey = key;

    this.label = 'Close'

    if (this.projectName !== '') {

      this.label = `Close '${this.projectName}'`;
    }
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    this.projects.closeProject();

    return true;
  }
}
